import {
  consent_api,
  customer_api,
  loan_application_api,
  person_api,
} from '@axo/shared/data-access/api';
import { amountOfChildrenHandlerFactory } from './amountOfChildren';
import { carHandlerFactory } from './carHandler';
import { childHandlerFactory } from './childHandler';
import { coCustomerHandlerFactory } from './coCustomerHandler';
import { consentHandlerFactory } from './consentHandler';
import { coPersonHandlerFactory } from './coPersonHandler';
import { customerHandlerFactory } from './customerHandler';
import { debtHandlerFactory } from './debtHandler';
import { expenseHandlerFactory } from './expenseHandler';
import { leadHandlerFactory } from './leadHandler';
import { loanApplicationHandlerFactory } from './loanApplicationHandler';
import { marketingConsentHandlerFactory } from './marketingConsentHandler';
import { personHandlerFactory } from './personHandler';

export const customerHandler = customerHandlerFactory({
  postCustomer: customer_api.postCustomer,
  patchCustomer: customer_api.patchCustomer,
  patchLoanApplication: loan_application_api.patchLoanApplication,
});

export const marketingConsentHandler = marketingConsentHandlerFactory({
  patchCustomer: customer_api.patchCustomer,
});

export const coCustomerHandler = coCustomerHandlerFactory({
  postCustomer: customer_api.postCustomer,
  patchCustomer: customer_api.patchCustomer,
  patchLoanApplication: loan_application_api.patchLoanApplication,
});

export const loanApplicationHandler = loanApplicationHandlerFactory({
  postLoanApplication: loan_application_api.postLoanApplication,
  patchLoanApplication: loan_application_api.patchLoanApplication,
});

export const consentHandler = consentHandlerFactory({
  postConsent: consent_api.sendMasterConsent,
});

export const debtHandler = debtHandlerFactory({
  postDebt: loan_application_api.postDebt,
  patchDebt: loan_application_api.patchDebt,
  deleteDebt: loan_application_api.deleteDebt,
});

export const personHandler = personHandlerFactory({
  getPerson: person_api.getPerson,
  postPerson: person_api.postPerson,
  patchPerson: person_api.patchPerson,
  patchLoanApplication: loan_application_api.patchLoanApplication,
});

export const coPersonHandler = coPersonHandlerFactory({
  getPerson: person_api.getPerson,
  postPerson: person_api.postPerson,
  patchPerson: person_api.patchPerson,
  patchLoanApplication: loan_application_api.patchLoanApplication,
});

export const expenseHandler = expenseHandlerFactory({
  postExpense: loan_application_api.postExpense,
  patchExpense: loan_application_api.patchExpense,
});

export const amountOfChildrenHandler = amountOfChildrenHandlerFactory({
  postChild: loan_application_api.postChild,
  deleteChild: loan_application_api.deleteChild,
});

export const carHandler = carHandlerFactory({
  postCar: loan_application_api.postCar,
  patchCar: loan_application_api.patchCar,
  deleteCar: loan_application_api.deleteCar,
});

export const childHandler = childHandlerFactory({
  postChild: loan_application_api.postChild,
  patchChild: loan_application_api.patchChild,
  deleteChild: loan_application_api.deleteChild,
});

export const leadHandler = leadHandlerFactory({
  postLead: loan_application_api.postLead,
  deleteLead: loan_application_api.deleteLead,
});
